import React from "react";
import { Zap, ShieldCheck, Tag, Users } from "lucide-react";
import { MOVING_URL } from "@/i18n";

const ICONS = [Zap, ShieldCheck, Tag, Users];

export default function WhyUs({ t }) {
  return (
    <section id="why" className="bg-[#F4F4F5] border-b-2 border-black" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="border-2 border-black overflow-hidden h-[360px] md:h-[480px]">
            <img src={MOVING_URL} alt="Moving" className="w-full h-full object-cover" />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-xs font-bold tracking-[0.22em] text-[#E11D2E]">{t.why.eyebrow}</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">
            {t.why.title}
          </h2>

          <div className="mt-10 grid sm:grid-cols-2 gap-0 border-2 border-black bg-white">
            {t.why.items.map((it, i) => {
              const Icon = ICONS[i];
              return (
                <div
                  key={i}
                  className="p-6 md:p-7 border-r-2 border-b-2 border-black last:border-r-0 sm:[&:nth-child(even)]:border-r-0 sm:[&:nth-last-child(-n+2)]:border-b-0"
                  data-testid={`why-item-${i}`}
                >
                  <div className="w-10 h-10 flex items-center justify-center border-2 border-black bg-[#E11D2E] text-white">
                    <Icon size={20} strokeWidth={2} />
                  </div>
                  <div className="mt-5 font-display text-xl md:text-2xl">{it.k}</div>
                  <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{it.v}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
